module.exports = __webpack_public_path__ + "img/keyboard_arrow_down.a14bacb5.svg";